import React, { Component } from 'react'
import img from '../../images/spa/cover_face.jpg'
import img2 from '../../images/spa/cover_back.jpg'
import img3 from '../../images/spa/cover_scrub.jpg'
import img4 from '../../images/spa/cover_footmassage.jpg'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { changePage, subMenuTitle } from '../../action/spa'

class MainMenu extends Component {
    goToSubMenu = (nextPage, title) => {
        this.props.changePage(nextPage);
        this.props.subMenuTitle(title);
    }
    render() {
        return (
            <div id="spa-main" class="movie-widgets">
                <h4>Spa booking</h4>
                <ul class="movie-widgets-list">
                    <li onClick={() => { this.goToSubMenu("myReservations", "Face") }}
                        data-target="spa-reservation-list">
                        <a style={{ top: 0, borderRadius: "15px" }}>
                            <i class="fa fa-list"></i>
                            <span>My Reservations</span>
                        </a>
                    </li>
                    <li onClick={() => { this.goToSubMenu("subMenu", "Face") }}
                        data-target="spa-menu-list"
                        style={{ background: `url('${img}') center center no-repeat`, backgroundSize: "cover" }}>
                        <a ><span>Face</span></a>
                    </li>
                    <li onClick={() => { this.goToSubMenu("subMenu", "Back") }}
                        data-target="spa-menu-list"
                        style={{ background: `url('${img2}') center center no-repeat`, backgroundSize: "cover" }}>
                        <a ><span>Back</span></a>
                    </li>
                    <li onClick={() => { this.goToSubMenu("subMenu", "Body") }}
                        data-target="spa-menu-list"
                        style={{
                            background: `url('${img3}') center center no-repeat`,
                            backgroundSize: "cover"
                        }}>
                        <a ><span>Body scrub</span></a>
                    </li>
                    <li onClick={() => { this.goToSubMenu("subMenu", "Foot") }}
                        data-target="spa-menu-list"
                        style={{ background: `url('${img4}') center center no-repeat`, backgroundSize: "cover" }}>
                        <a ><span>Foot</span></a>
                    </li>
                </ul>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        currentPage: state.store.spa.currentPage
    }
}

export default connect(
    mapStateToProps,
    {
        changePage,
        subMenuTitle
    }
)(MainMenu);
